<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import launchpadBackground from '$assets/launchpad/launchpad-background.webp';
	import * as m from '$paraglide/messages';
	import AdSection from './AdSection.svelte';
	import Cost from './Cost.svelte';
	import Magazine from './Magazine.svelte';
	import Selection from './Selection.svelte';
	import Zois from './Zois.svelte';

	type ComponentType = typeof Zois | typeof Cost | typeof AdSection | typeof Selection | typeof Magazine;
	type SectionType = { component: ComponentType; active: boolean };

	const launchpadSections = new Map<string, SectionType >([
		['zois', { component: Zois, active: true }],
		['cost', { component: Cost, active: true }],
		['ad', { component: AdSection, active: true }],
		['magazine', { component: Magazine, active: true }],
		['selection', { component: Selection, active: true }],
	]);

	interface Props {
		class?: ClassValue;
	}

	const { class: classes }: Props = $props();
</script>

<div class={['launchpad no-repeat min-h-full bg-[size:cover]', classes]} style="background-image: url('{launchpadBackground}')">
	<header class="w-full">
		<h2 class="text-gradient text-center text-lg font-400 my-0">{m.launchpad__headline_title()}</h2>
	</header>
	{#each [...launchpadSections.entries()] as [sectionId, { component: SvelteComponent, active }] (sectionId)}
		{#if active}
			<SvelteComponent />
		{/if}
	{/each}
</div>

<style>
	.launchpad {
		background-position: calc(0% - 16px) 0;
	}
	.text-gradient {
		background: linear-gradient(111.7deg, #274D90 35.77%, #1D3140 58.22%);
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
</style>
